import { MobileDemoUsersModalComponent } from './../mobile-demo-users-modal/mobile-demo-users-modal.component';
import { NgbModal, NgbModalRef, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";

import { demoUsersModal } from "./demoUsers.component";

export function showDemoUsersModal(modalService: NgbModal, idToEdit = 0, mobileMode = 'desktop') {
    const mobile = mobileMode != 'desktop';
    const component = mobile? MobileDemoUsersModalComponent: demoUsersModal;
    const windowClass = "dark-modal" + (mobile? ' mobile': '');
    let opt: NgbModalOptions = {
        backdrop: "static",
        centered: true,
        windowClass: windowClass,
        size: "sm"
    };
    let m: NgbModalRef = modalService.open(component, opt);
    let modal = (<demoUsersModal>m.componentInstance);

    if(idToEdit != 0)
    {
        modal.idToEdit = idToEdit;
        modal.dissmissAfterEdit = true;
        modal.modalSubType = "standard";
    }
}

export function ShowAddNewPUserSetModal(modalService: NgbModal, mobileMode = 'desktop') {
    const mobile = mobileMode != 'desktop';
    const component = mobile? MobileDemoUsersModalComponent: demoUsersModal;
    const windowClass = "dark-modal" + (mobile? ' mobile': '');
    let opt: NgbModalOptions = {
        backdrop: "static",
        centered: true,
        windowClass: windowClass,
        size: "sm"
    };
    let m: NgbModalRef = modalService.open(component, opt);
    let modal = (<demoUsersModal>m.componentInstance);

    modal.modalSubType = "addNewUser";
}

export function ShowAddDeleteUserModal(modalService: NgbModal,delid:any, mobileMode = 'desktop') {
    const mobile = mobileMode != 'desktop';
    const component = mobile? MobileDemoUsersModalComponent: demoUsersModal;
    const windowClass = "dark-modal" + (mobile? ' mobile': '');
    let opt: NgbModalOptions = {
        backdrop: "static",
        centered: true,
        windowClass: windowClass,
        size: "sm"
    };
    let m: NgbModalRef = modalService.open(component, opt);
    let modal = (<demoUsersModal>m.componentInstance);

    modal.modalSubType = "deleteUser";
    modal.idToDelete = delid;
}

export function ShowEditUserModal(modalService: NgbModal,editid:any, mobileMode = 'desktop') {
    const mobile = mobileMode != 'desktop';
    const component = mobile? MobileDemoUsersModalComponent: demoUsersModal;
    const windowClass = "dark-modal" + (mobile? ' mobile': '');
    let opt: NgbModalOptions = {
        backdrop: "static",
        centered: true,
        windowClass: windowClass,
        size: "sm"
    };
    let m: NgbModalRef = modalService.open(component, opt);
    let modal = (<demoUsersModal>m.componentInstance);

    modal.modalSubType = "EditUser";
    modal.idToEdit = editid;
}